module.exports = __webpack_public_path__ + "img/9-24.d4404a8e.jpg";